export default __webpack_public_path__ + "static/media/bb16.41b06ae0.webp";